import React from 'react';
import { OnboardingWizard } from '../../features/onboarding/components/OnboardingWizard';

export const OnboardingPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-4">
      <OnboardingWizard />
    </div>
  );
};
